/**
 * Generate a new URL with the given base URL and parameters
 * @param baseUrl - The base URL
 * @param params - The parameters to append to the URL
 * @returns The generated URL
 * @example
 * ```ts
 * const baseUrl = 'https://example.com/image.jpg';
 * const params = { width: '100', height: '100' };
 * const url = generateURLWithParams(baseUrl, params);
 * console.log(url); // 'https://example.com/image.jpg?width=100&height=100'
 * ```
 *  */

export const generateUrlWithParams = (baseUrl: string, params: Record<string, string>): string => {
  const url = new URL(baseUrl);
  Object.keys(params).forEach((key) => {
    url.searchParams.append(key, params[key]);
  });

  return url.toString();
};
